import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Sticky } from 'react-sticky';
import { fetchDefaultGiftCard, search, updateSort, reset } from '../../actions/RegistryCollectionActions';
import { getCartSize } from '../../actions/CartActions';
import RegistryProducts from './RegistryProducts';
import RegistrySidebar from './RegistrySidebar';
import { showModal } from '../../actions/ModalActions';
import { identifyGuestUser } from '../../actions/UserActions';
import Loader from '../common/ui/Loader';

import '../../stylesheets/pages/PublicRegistry.less';
import { fetchRegistry } from '../../actions/RegistryActions';
import featureFlags from '../../util/featureFlags';

class ZolaRegistry extends Component {
  constructor(props) {
    super(props);

    this.changeView = this.changeView.bind(this);
    this.updateSort = this.updateSort.bind(this);
    this.initializeRegistry = this.initializeRegistry.bind(this);

    this.state = {
      view: 'grid',
      registryInitialized: false,
      optimizelyTeaseRegistryView: window.optimizelyTeaseRegistryView || false
    };
  }

  componentDidMount() {
    const { isDefaultGiftCardEnabled, getDefaultGiftCard, onSearch, onCartSize, forPreview, getRegistry, onGuestVisit } = this.props;

    if (isDefaultGiftCardEnabled) {
      getDefaultGiftCard();
    }

    if (forPreview) {
      getRegistry().then(() => {
        const { enableCustomCollections } = this.props;
        onSearch(enableCustomCollections);
        this.initializeRegistry();
      });
    } else {
      const { enableCustomCollections } = this.props;
      onSearch(enableCustomCollections);
      this.initializeRegistry();
    }

    onCartSize();
    onGuestVisit();
  }

  componentWillUnmount() {
    const { onReset } = this.props;
    onReset();
  }

  initializeRegistry() {
    this.setState({ registryInitialized: true });
  }

  changeView(newView) {
    this.setState({
      view: newView
    });
  }

  updateSort(event) {
    const { onSearch, onUpdateSort, enableCustomCollections } = this.props;
    onUpdateSort(event.target.value);
    onSearch(enableCustomCollections);
  }

  optionalStickyWrapper(inner, hasOtherRegistries, stickyHeaderProps) {
    // for AB test
    if (featureFlags.get('persistentCart')) {
      return (
        <div id="registry-header" className={`registry-header registry-weddings-header${hasOtherRegistries ? '' : ' with-border'}`} {...stickyHeaderProps}>
          {inner}
        </div>
      );
    }
    return (
      <Sticky id="registry-header" className={`registry-header registry-weddings-header${hasOtherRegistries ? '' : ' with-border'}`} {...stickyHeaderProps}>
        {inner}
      </Sticky>
    );
  }

  render() {
    const { registryCollections, cartSize, onCart, sort, publicWebsite, hasOtherRegistries, forPreview, enableCustomCollections, defaultGiftCard } = this.props;
    const { view, registryInitialized } = this.state;
    const stickyHeaderProps = { topOffset: 40, stickyStyle: { zIndex: 99 } };

    if (forPreview) {
      stickyHeaderProps.isActive = false;
    }

    if (!registryInitialized) {
      return null;
    }

    // if we're returning from Registry, bring user to previous location
    if (window.optimizelyOpenFullPagePdp && registryInitialized && window.location.hash !== '') {
      const scrollY = window.location.hash.substring(1);
      setTimeout(() => { window.scrollTo(0, scrollY); }, 1000);
    }

    return (
      <div id="registry-zola" className="zola-registry-styles">
        {this.optionalStickyWrapper(
          <div className="container-fluid registry-nav">
            <div className="row">
              <div className="col-xs-4 col-sm-5 text-left left-buttons nav-item">
                {publicWebsite.registry_marketing_message ? (
                  <span className="hidden-xs hidden-sm">
                    <i className="zolaicon zolaicon-gift" />
                    <a href={publicWebsite.registry_marketing_message_link} target="_blank" rel="noopener noreferrer" className="small">
                      {publicWebsite.registry_marketing_message} <span className="ship-details">{publicWebsite.registry_marketing_message_sub_copy}</span>
                    </a>
                  </span>
                ) : (
                  <span className="hidden-xs hidden-sm">
                    <i className="zolaicon zolaicon-truck" />
                    <a href="/shipping" target="_blank" rel="noopener noreferrer">Free Shipping Every Day <span className="ship-details">Details &rsaquo;</span></a>
                  </span>
                )}
                <strong className="right-action visible-xs-inline-block visible-sm-inline-block small">1-408-657-ZOLA</strong>
              </div>
              <div className="col-xs-4 col-sm-2 text-center">
                <div className="zola-registry-logo-light" />
                <div className="zola-registry-logo-dark" />
              </div>
              <div className="col-xs-4 col-sm-5 text-right nav-item right-buttons">
                <strong className="right-action hidden-sm hidden-xs">1-408-657-ZOLA</strong>
                {
                  !featureFlags.get('persistentCart') && (
                    <a role="button" className="cart-modal-link with-icon" onClick={onCart}>
                      {cartSize > 0 && <span className="badge">{cartSize}</span>}
                      <i className="zolaicon zolaicon-cart" />
                    </a>
                  )
                }
              </div>
            </div>
          </div>, hasOtherRegistries, stickyHeaderProps
        )}
        <div id="public-registry" className="container-fluid">
          <div className="row zola-registry-message">
            {window.zola.env !== 'production' ? (
              <div className="col-xs-12 text-center">
                <p className=""><small className="font-family-serif bold text-uppercase">What is Zola Registry?</small> As the wedding registry experts, we have everything couples need to start newlywed life off right. <a href="/wedding-registry/guest-reviews" role="button" className="text-uppercase semibold small">Learn More ›</a></p>
              </div>
            ) : (
              <div className="col-xs-12 text-center">
                <p className=""><small className="font-family-serif bold text-uppercase">What is Zola Registry?</small> As the wedding registry experts, we have everything couples need to start newlywed life off right. <a href="/wedding-registry/guest-reviews" role="button" className="text-uppercase semibold small">Learn More ›</a></p>
              </div>
            )}
          </div>
          {registryCollections.initialized ? (
            <div className="row registry-body">
              <RegistrySidebar forPreview={forPreview} onUpdateSort={this.updateSort} enableCustomCollections={enableCustomCollections} />
              <div className="hidden-xs hidden-sm grid-controls form-inline col-md-9 col-lg-10">
                <div className="btn-group">
                  <a role="button" className={`btn btn-secondary${view === 'grid' ? ' active' : ''}`} onClick={() => this.changeView('grid')}>
                    <i className="glyphicon glyphicon-th-large" />&nbsp; GRID
                  </a>
                  <a role="button" className={`btn btn-secondary${view === 'list' ? ' active' : ''}`} onClick={() => this.changeView('list')}>
                    <i className="glyphicon glyphicon-th-list" />&nbsp; LIST
                  </a>
                </div>
                <div className="form-group sort-control">
                  <label htmlFor="public-registry-sort" className="control-label">Sort by:</label>
                  <select id="public-registry-sort" name="public-registry-sort" className="form-control" onChange={this.updateSort} value={sort}>
                    <option value="">Featured</option>
                    <option value="MOST_WANTED" label="Couple's Most Wanted">Couple&apos;s Most Wanted</option>
                    <option value="PRICE_ASC" label="Price: Low to High">Price: Low to High</option>
                    <option value="PRICE_DESC" label="Price: High to Low">Price: High to Low</option>
                  </select>
                </div>
              </div>
              <div className="col-xs-12 col-md-9 col-lg-10">
                <RegistryProducts
                  view={view}
                  registryCollections={registryCollections}
                  defaultGiftCard={defaultGiftCard}
                  enableCustomCollections={enableCustomCollections}
                  optimizelyTeaseRegistryView={this.state.optimizelyTeaseRegistryView}
                />
              </div>
            </div>
          ) : (
            <Loader delay />
          )}
        </div>
        <div className="row">
          <div className="row zola-registry-message margin-top-2x">
            <div className="col-xs-12 text-center">
              <p>Need help finding the perfect gift from Zola Registry? Reach out to us at <a href="mailto:support@zola.com">support@zola.com</a> or 1 (408) 657-ZOLA (9652).</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ZolaRegistry.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  enableCustomCollections: true,
};

ZolaRegistry.propTypes = {
  defaultGiftCard: PropTypes.shape({}),
  registryCollections: PropTypes.shape({}),
  registry: PropTypes.shape({}),
  publicWebsite: PropTypes.shape({
    registry_marketing_message: PropTypes.string,
    registry_marketing_message_sub_copy: PropTypes.string,
    registry_marketing_message_link: PropTypes.string
  }),
  onSearch: PropTypes.func.isRequired,
  onUpdateSort: PropTypes.func.isRequired,
  onCart: PropTypes.func.isRequired,
  cartSize: PropTypes.number,
  onCartSize: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired, // eslint-disable-line
  sort: PropTypes.string,
  // onAboutZola: PropTypes.func.isRequired,
  // onAboutZolav2: PropTypes.func.isRequired,
  hasOtherRegistries: PropTypes.bool.isRequired,
  forPreview: PropTypes.bool,
  enableCustomCollections: PropTypes.bool.isRequired,
  isDefaultGiftCardEnabled: PropTypes.bool,
  getRegistry: PropTypes.func.isRequired,
  onGuestVisit: PropTypes.func.isRequired,
  getDefaultGiftCard: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  defaultGiftCard: state.registryCollections.defaultGiftCard,
  registry: state.registry,
  registryCollections: state.registryCollections,
  publicWebsite: state.publicWebsite.wedding,
  isDefaultGiftCardEnabled: state.registry.default_gift_card_enabled || state.publicWebsite.zolaRegistry.default_gift_card_enabled,
  cartSize: state.cart.size,
  sort: state.registryCollections.sort,
  enableCustomCollections: ownProps.forPreview ? state.registry.enable_custom_collections : state.publicWebsite.zolaRegistry.enable_custom_collections,
});

const mapDispatchToProps = dispatch => ({
  onSearch: enableCustomCollections => dispatch(search(enableCustomCollections)),
  onUpdateSort: sort => dispatch(updateSort(sort)),
  onCart: () => dispatch(showModal('CART_MODAL')),
  onCartSize: () => dispatch(getCartSize()),
  onReset: () => dispatch(reset()),
  // onAboutZola: () => dispatch(showModal('ABOUT_ZOLA')),
  // onAboutZolav2: () => dispatch(showModal('ABOUT_ZOLA_V2')),
  getRegistry: () => dispatch(fetchRegistry()),
  getDefaultGiftCard: () => dispatch(fetchDefaultGiftCard()),
  onGuestVisit: () => dispatch(identifyGuestUser()),
});

const ZolaRegistryContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ZolaRegistry);

export default ZolaRegistryContainer;



// WEBPACK FOOTER //
// ./src/components/registry/ZolaRegistry.jsx